export enum AllCardsGames {
  AUS_4D = "AUS_4D",
  LUCKY_BALL = "LUCKY_BALL",
  THREE_BALL = "THREE_BALL",
  ODDS_EVEN = "ODDS_EVEN",
  MISS_MATCH = "MISS_MATCH",
  SINGLE_BET = "SINGLE_BET",
  TRADITIONAL_BET = "TRADITIONAL_BET",
  PACKAGE_BET = "PACKAGE_BET",
  PRO_BET = "PRO_BET",
}

export enum ParentGames {
  LUCKY_7 = "LUCKY_7",
  LOTTO_4D = "LOTTO_4D",
  TURBO = "TURBO",
  SUGAR = "SUGAR",
}

export const GroupedGameMap: Record<ParentGames, AllCardsGames[]> = {
  [ParentGames.LUCKY_7]: [
    AllCardsGames.AUS_4D,
    AllCardsGames.LUCKY_BALL,
    AllCardsGames.THREE_BALL,
    AllCardsGames.ODDS_EVEN,
    AllCardsGames.MISS_MATCH,
  ],
  [ParentGames.LOTTO_4D]: [
    AllCardsGames.SINGLE_BET,
    AllCardsGames.TRADITIONAL_BET,
    AllCardsGames.PACKAGE_BET,
    AllCardsGames.PRO_BET,
  ],
  [ParentGames.TURBO]: [],
  [ParentGames.SUGAR]: [],
};

export const GameToParentMap: Record<AllCardsGames, ParentGames> = {
  [AllCardsGames.AUS_4D]: ParentGames.LUCKY_7,
  [AllCardsGames.LUCKY_BALL]: ParentGames.LUCKY_7,
  [AllCardsGames.THREE_BALL]: ParentGames.LUCKY_7,
  [AllCardsGames.ODDS_EVEN]: ParentGames.LUCKY_7,
  [AllCardsGames.MISS_MATCH]: ParentGames.LUCKY_7,
  [AllCardsGames.SINGLE_BET]: ParentGames.LOTTO_4D,
  [AllCardsGames.TRADITIONAL_BET]: ParentGames.LOTTO_4D,
  [AllCardsGames.PACKAGE_BET]: ParentGames.LOTTO_4D,
  [AllCardsGames.PRO_BET]: ParentGames.LOTTO_4D,
};
